import ClockIcon from './component.jsx'
export default ClockIcon
